import { Outlet, createFileRoute } from '@tanstack/react-router';

import { RequireEntitlements } from '@/components/Auth/RequireEntitlements';
import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';

export const Route = createFileRoute('/$organizationName/settings/machines')({
  component: SecuredMachinesPage,
});

function SecuredMachinesPage() {
  return (
    <RequireEntitlements admins={['isSuperAdmin']}>
      <SettingsPageLayout
        fullWidthWithPadding
        newHeader
        hideSeparator
        title="Machines"
        subTitle="Machines are identities for CI/CD pipelines and automated systems to access Driver."
      >
        <Outlet />
      </SettingsPageLayout>
    </RequireEntitlements>
  );
}
